<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :block="$vuetify.breakpoint.smAndDown"
        color="hrissecondary"
        class="white--text px-10"
        v-on="on"
      >
        Create Job Group
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Job Group"
      text="Create Job Group"
      class="mb-0"
    >
      <form>
        <v-container v-if="dialog">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="leaveEntitlementSetting"
                :error-messages="errors.collect('leaveEntitlementSetting')"
                :items="leaveEntitlementSettings"
                data-vv-name="leaveEntitlementSetting"
                data-vv-as="leave entitlement"
                item-text="name"
                item-value="id"
                multiple
                chips
                hide-selected
                hide-no-data
                outlined
                deletable-chips
                label="Leave Entitlement"
              />
            </v-col> 
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"           
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        name: null,
        leaveEntitlementSettings: [],
        leaveEntitlementSetting: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadLeaveEntitlementSettings()
        } else {
          this.$resetData()
        }
      },
    },
    methods: {     
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.progressing = true
            
            this.$api.jobGroups().create({ name: this.name, leaveEntitlementSettings: this.leaveEntitlementSetting })
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.progressing = false
                this.dialog = false
              })
          })
      },

      loadLeaveEntitlementSettings () {
        this.$api.leaveEntitlementSettings().list()
          .then(res => {
            this.leaveEntitlementSettings = res.data
          })
      },
    },
  }
</script>
